// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import ContractList = API.ContractList;
import Contract = API.Contract;
import Artist = API.Artist;
import SalesList = API.SalesList;

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/user/getUserInfo', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/user/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

// 获取合同列表 GET /api/contracts
export async function getContracts(options?: { [key: string]: any }) {
  return request<API.CommonResult<ContractList>>('/api/contract/list', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getDraftContracts(options?: { [key: string]: any }) {
  return request<API.CommonResult<ContractList>>('/api/contract/listDraftContracts', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getReportsByContractId(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.ContractReportList>>('/api/report/getReportList', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function exportReportList(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.ContractReportList>>('/api/report/exportReportList', {
    method: 'GET',
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}



export async function exportReport(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.ContractReportList>>('/api/report/exportReport', {
    method: 'GET',
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}

export async function sendEmailCode(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.ContractReportList>>('/api/email/sendCode', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 获取艺人列表
export async function fetchArtists(options?: { artistName?: string; page?: number; size?: number }) {
  return request<API.CommonResult<string[]>>('/api/artistAndSongs/artist', {
    method: 'GET',
    params: {
      page: options?.page || 1,
      size: options?.size || 5,
      artistName: options?.artistName || '',
    },
  });
}

export async function fetchArtistBalance( ) {
  return request<API.CommonResult<number>>('/api/artist/getBalance', {
    method: 'GET',
    params: {
    },
  });
}

export async function fetchBalanceHistory(options?: {
  changeTimeStart?: string;
  changeTimeEnd?: string;
  relatedReport?: string;
  relatedContract?: string;
  sortField?: string;
  isAscending?: boolean;
  page?: number;
  size?: number;
}) {
  return request<API.CommonResult<API.BalanceHistoryList>>('/api/artist/getBalanceHistory', {
    method: 'GET',
    params: {
      changeTimeStart: options?.changeTimeStart,
      changeTimeEnd: options?.changeTimeEnd,
      relatedReport: options?.relatedReport,
      relatedContract: options?.relatedContract,
      sortField: options?.sortField,
      isAscending: options?.isAscending ?? true, // 默认为 true
      page: options?.page || 1,
      size: options?.size || 5,
    },
  });
}

export async function fetchBalanceHistoryAdmin(options?: {
  artistId?:string;
  changeTimeStart?: string;
  changeTimeEnd?: string;
  relatedReport?: string;
  relatedContract?: string;
  sortField?: string;
  isAscending?: boolean;
  page?: number;
  size?: number;
}) {
  return request<API.CommonResult<API.BalanceHistoryList>>('/api/artist/getBalanceHistoryAdmin', {
    method: 'GET',
    params: {
      artistId: options?.artistId,
      changeTimeStart: options?.changeTimeStart,
      changeTimeEnd: options?.changeTimeEnd,
      relatedReport: options?.relatedReport,
      relatedContract: options?.relatedContract,
      sortField: options?.sortField,
      isAscending: options?.isAscending ?? true, // 默认为 true
      page: options?.page || 1,
      size: options?.size || 5,
    },
  });
}


// 获取歌曲列表
export async function fetchSongs(options?: { artistName?: string; songName?: string; page?: number; size?: number }) {
  return request<API.CommonResult<API.SongResponse[]>>('/api/artistAndSongs/songs', {
    method: 'GET',
    params: {
      page: options?.page || 1,
      size: options?.size || 5,
      artistName: options?.artistName || '',
      songName: options?.songName || '',
    },
  });
}

export async function getTaskList(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.TaskList>>('/api/task/getTaskList', {
    method: 'GET',
    ...(options || {}),
  });
}
export async function getTaskCanUploadStatus(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.TaskList>>('/api/task/getTaskCanUploadStatus', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getReportsBreakDownByContractId(options?: { [key: string]: any }) {
  return request<API.CommonResult<API.ContractReportBreakDownList>>('/api/report/getReportBreakDown', {
    method: 'GET',
    ...(options || {}),
  });
}

// 获取合同列表 GET /api/contracts
export async function getContract(options?: { [key: string]: any }) {
  return request<API.CommonResult<Contract>>('/api/contract/get', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function confirmEmail(options?: { [key: string]: any }) {
  return request<API.CommonResult<Artist>>('/api/contract/confirmEmail', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function searchArtistByNameApi(options?: { [key: string]: any }) {
  return request<API.CommonResult<Artist>>('/api/contract/searchArtistByName', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function searchArtistByEmailApi(options?: { [key: string]: any }) {
  return request<API.CommonResult<Artist>>('/api/contract/searchArtistByEmail', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function addContract(options?: { [key: string]: any }) {
  return request<API.CommonResult<Contract>>('/api/contract/add', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

export async function generateReportForContract(options?: { [key: string]: any }) {
  return request<API.CommonResult<Contract>>('/api/report/generateReportForContract', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

export async function updateContract(options?: { [key: string]: any }) {
  return request<API.CommonResult<Contract>>('/api/contract/update', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

export async function confirmSong(options?: { [key: string]: any }) {
  return request<API.CommonResult<SalesList>>('/api/contract/confirmSong', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getArtistList(options?: { [key: string]: any }) {
  return request<API.CommonResult<Artist[]>>('/api/artist/getArtistsList', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getArtistById(options?: { [key: string]: any }) {
  return request<API.CommonResult<Artist[]>>('/api/artist/get', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function updateArtist(options?: { [key: string]: any }) {
  return request<API.CommonResult<Contract>>('/api/artist/update', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

export async function addArtist(options?: { [key: string]: any }) {
  return request<API.CommonResult<Contract>>('/api/artist/add', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 上传文件 POST /api/upload
export async function uploadBelieveFile(file: File, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  // formData.append('fileType', fileType);

  return request<API.CommonResult<any>>('/api/sales/believe/uploadSalesRecord', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...(options || {}),
  });
}

export async function uploadFailedBelieveFile(file: File, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  // formData.append('fileType', fileType);

  return request<API.CommonResult<any>>('/api/sales/failed/uploadSalesRecord', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...(options || {}),
  });
}

export async function uploadStreetVoiceFile(file: File, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  // formData.append('fileType', fileType);

  return request<API.CommonResult<any>>('/api/sales/streetVoice/uploadSalesRecord', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...(options || {}),
  });
}

export async function uploadNeteaseFile(file: File, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  // formData.append('fileType', fileType);

  return request<API.CommonResult<any>>('/api/sales/netease/uploadSalesRecord', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...(options || {}),
  });
}
export async function uploadNeteaseShenglangFile(file: File, options?: { [key: string]: any }) {
  const formData = new FormData();
  formData.append('file', file);
  // formData.append('fileType', fileType);

  return request<API.CommonResult<any>>('/api/sales/netease/shenglang/uploadSalesRecord', {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...(options || {}),
  });
}


// 下载 Excel 表格 GET /sales/streetVoice/exportFailedSales
export async function downloadStreetVoiceExcel(taskId: string, options?: { [key: string]: any }) {
  return request('/api/sales/streetVoice/exportFailedSales', {
    method: 'GET',
    params: {
      taskId,
    },
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}

export async function downloadBelieveExcel(taskId: string, options?: { [key: string]: any }) {
  return request('/api/sales/believe/exportFailedSales', {
    method: 'GET',
    params: {
      taskId,
    },
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}

export async function downloadReportPdf(options?: { [key: string]: any }) {
  return request('/api/report/exportPdf', {
    method: 'GET',
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}

export async function downloadSalesList(options?: { [key: string]: any }) {
  return request('/api/report/exportRelatedSalesList', {
    method: 'GET',
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}

export async function deleteTaskApi(taskId: string, options?: { [key: string]: any }) {
  return request('/api/task/deleteTask', {
    method: 'POST',
    params: {
      taskId,
    },
    ...(options || {}),
  });
}

export async function redoTaskApi(taskId: string, options?: { [key: string]: any }) {
  return request('/api/task/redoTask', {
    method: 'POST',
    params: {
      taskId,
    },
    ...(options || {}),
  });
}

export async function cancelTaskApi(taskId: string, options?: { [key: string]: any }) {
  return request('/api/task/cancelTask', {
    method: 'POST',
    params: {
      taskId,
    },
    ...(options || {}),
  });
}

export async function downloadNeteaseExcel(taskId: string, options?: { [key: string]: any }) {
  return request('/api/sales/netease/exportFailedSales', {
    method: 'GET',
    params: {
      taskId,
    },
    responseType: 'blob', // 设置响应类型为 blob
    ...(options || {}),
  });
}

export async function getLogs(params: { page: number; size: number }, options?: { [key: string]: any }) {
  return request<API.LogList>('/api/log/get', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function sendReport(params: { reportId:string }, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/report/sendReport', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function confirmReport(params: { reportId:string }, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/report/confirmReport', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function deleteReport(params: { reportId:string }, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/report/deleteReport', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function payContract(params: { contractId:string }, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/contract/payContract', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
export async function payReport(params: { reportId:string }, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/report/payReport', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function resetPassword(params: { password:string }, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/user/resetPassword', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function addExtra(options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/report/addExtra', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 获取汇率列表 GET /api/exchangeRates
export async function getExchangeRates(options?: { [key: string]: any }) {
  return request<API.ExchangeRateList>('/api/currency/list', {
    method: 'GET',
    ...(options || {}),
  });
}

// 设置汇率 POST /api/exchangeRates
export async function setExchangeRate(rate: API.ExchangeRate, options?: { [key: string]: any }) {
  return request<API.CommonResult<any>>('/api/currency/set', {
    method: 'POST',
    data: rate,
    ...(options || {}),
  });
}

// 生成报告 POST /api/generateReport
export async function generateReport(options?: { [key: string]: any }) {
  return request<API.GenerateReportResult>('/api/report/generateReport', {
    method: 'POST',
    ...(options || {}),
  });
}

